// src/services/renderIcon.js
import React from "react";
import { FcFolder } from "react-icons/fc";
import { BsFiletypeMp4, BsFiletypeExe, BsCardImage, BsFiletypeTxt } from "react-icons/bs";
import { SiLibreofficewriter, SiUtorrent } from "react-icons/si";
import { MdLocalMovies, MdOutlineComment, MdOutlineVideogameAsset } from "react-icons/md";
import { FaFilePdf, FaFileWord } from "react-icons/fa";
import { GoFileBinary } from "react-icons/go";
import { CgDisc } from "react-icons/cg";
import { ImFileZip } from "react-icons/im";
import { FaCompactDisc } from "react-icons/fa6";
import { RiSwitchFill } from "react-icons/ri";
import { PiFolderUser } from "react-icons/pi"; // lembre de instalar: react-icons/pi

/**
 * Retorna o ícone correspondente à extensão do arquivo.
 * 
 * @param {string} extension - Extensão do arquivo (ex: ".mp4", ".pdf")
 * @param {string} [name] - Nome do arquivo ou diretório (usado para casos especiais)
 * @returns {JSX.Element} Ícone apropriado
 */
export const renderIcon = (extension, name = "") => {
  switch (extension?.toLowerCase()) {
    case ".torrent": return <SiUtorrent style={{ color: "#2DEA55" }} className="folder-icon" />;
    case ".bin": return <GoFileBinary style={{ color: "#CCC" }} className="folder-icon" />;
    case ".odt": return <SiLibreofficewriter style={{ color: "#CCC" }} className="folder-icon" />;
    case ".doc": return <FaFileWord style={{ color: "#00F" }} className="folder-icon" />;
    case ".pdf": return <FaFilePdf style={{ color: "#B22222" }} className="folder-icon" />;
    case ".txt": return <BsFiletypeTxt style={{ color: "#D3D3D3" }} className="folder-icon" />;
    case ".mp4": return <BsFiletypeMp4 style={{ color: "#000" }} className="folder-icon" />;
    case ".mkv": return <MdLocalMovies style={{ color: "#000" }} className="folder-icon" />;
    case ".wma":
    case ".avi":
    case ".wav":
    case ".mp3": return <FaCompactDisc style={{ color: "#000" }} className="folder-icon" />;
    case ".exe": return <BsFiletypeExe style={{ color: "#1E90FF" }} className="folder-icon" />;
    case ".iso": return <CgDisc style={{ color: "#FF4500" }} className="folder-icon" />;
    case ".srt": return <MdOutlineComment style={{ color: "#000" }} className="folder-icon" />;
    case ".nsp":
    case ".nsz": return <RiSwitchFill style={{ color: "#FF5046" }} className="folder-icon" />;
    case ".png":
    case ".jpg":
    case ".jpeg": return <BsCardImage style={{ color: "#C0C0C0" }} className="folder-icon" />;
    case ".7z":
    case ".zip":
    case ".rar": return <ImFileZip style={{ color: "#C0C0C0" }} className="folder-icon" />;
    case ".gcm": return <MdOutlineVideogameAsset style={{ color: "#191970" }} className="folder-icon" />;
    default:
      return name === "Usuario"
        ? <PiFolderUser className="folder-icon" style={{ color: "#1E90FF" }} />
        : <FcFolder className="folder-icon" />;
  }
};
